import { TabLink } from '../TabLink';

import { tabs } from '../../../data/constants';

export const TabBar = ({
  activeTab = 0,
  activeUrgency = null,
  counters = {},
  isLoading = false,
  handleTabClick = () => {},
  handleCounterClick = () => {},
}) => {
  return (
    <>
      {!isLoading && (
        <div className="flex flex-wrap items-center gap-3 mb-5 w-full">
          {tabs.map(tab => (
            <TabLink
              key={tab.id}
              tab={tab}
              counters={counters[tab.value]}
              handleTabClick={handleTabClick}
              handleCounterClick={handleCounterClick}
              activeButton={activeTab}
              activeUrgency={activeUrgency}
            />
          ))}
        </div>
      )}
    </>
  );
};
